export default __webpack_public_path__ + "static/media/korpa1.97f969c5.svg";